module.exports = __webpack_public_path__ + "img/Show-N-Go-Icon-Prim.3353209a.svg";